import { Autocomplete, Box, Grid, TextField } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import { useField } from "formik";
import React from "react";

const EntryAutocomplete = ({
  label,
  name,
  placeholder,
  helper,
  // ...
  freeSolo,
  options = [],
  disabled,
  // ...
  sx = {},
  // ...
  xs = 12,
  md = 6,
}) => {
  const [field, meta, helpers] = useField({ name });
  // ...
  const iVals = field?.value;
  const ini = Array.isArray(iVals)
    ? { values: [...iVals] }
    : iVals || { values: [] };
  const values = ini?.values || [];
  // ...
  const handleChange = (e, values) => {
    const tmp = values.map((v) => {
      return typeof v === "string" ? { label: v, value: v } : { ...v };
    });
    helpers.setValue({ values: tmp });
  };
  const handleDelete = (opt) => {
    const tmp = values.filter((v) => v.value !== opt.value) || [];
    helpers.setValue({ values: tmp });
  };
  // ...
  return (
    <Grid item xs={xs} md={md}>
      <Box className="EntryAutocomplete">
        {!!helper && <div className="EntryAutocomplete__helper">{helper}</div>}
        <Autocomplete
          multiple
          filterSelectedOptions
          freeSolo={freeSolo}
          sx={{ ...sx }}
          // ...
          name={name}
          value={values}
          onChange={handleChange}
          onBlur={field.onBlur}
          options={options}
          disabled={disabled}
          // ...
          getOptionLabel={(option) => option.label}
          getOptionSelected={(option) => {
            const _exist = values?.filter((opt) => opt.value === option.value);
            return !!_exist.length;
          }}
          // ...
          renderTags={(value) => {
            return value?.map((option, idx) => <div key={idx} />);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              name={name}
              placeholder={placeholder}
            />
          )}
        />
        <Box className="EntryAutocomplete__chips">
          {values?.map((option, idx) => (
            <Chip
              key={idx}
              label={option.label}
              onDelete={() => handleDelete(option)}
            />
          ))}
        </Box>
      </Box>
    </Grid>
  );
};

export default EntryAutocomplete;
